import z from 'zod'

import { FeedbackStep } from './feedback'

export const changeRateMetricSchema = z.enum(['population', 'nitrogen', 'downforce'])

export const presentOptionsDirectiveSchema = z.object({
  command: z.literal('PresentOptions'),
  options: z.array(z.string())
})

export const permissionRequestSchema = z.object({
  id: z.string(),
  toolName: z.string(),
  args: z.record(z.string(), z.unknown())
})

export type PermissionRequest = z.infer<typeof permissionRequestSchema>

export const requestPermissionDirectiveSchema = z.object({
  command: z.literal('RequestPermission'),
  requests: z.array(permissionRequestSchema).min(1)
})

/**
 * Category ids are labeled by the client.
 */
export const collectFeedbackDirectiveSchema = z.object({
  command: z.literal('CollectFeedback'),
  step: z.discriminatedUnion('kind', [
    z.object({
      kind: z.literal(FeedbackStep.Category),
      categories: z.array(z.string()).min(1)
    }),
    z.object({ kind: z.literal(FeedbackStep.Details) })
  ])
})

export const agentDirectiveSchema = z.discriminatedUnion('command', [
  presentOptionsDirectiveSchema,
  requestPermissionDirectiveSchema,
  collectFeedbackDirectiveSchema
])

export type AgentDirective = z.infer<typeof agentDirectiveSchema>
